import CountryCode from "./CountryCode.js"
import LanguageCode from "./LanguageCode.js"

enum LocaleCode {
	en_US = `${LanguageCode.English}-${CountryCode.USA}`,
	es_AR = `${LanguageCode.Spanish}-${CountryCode.Argentina}`,
	es_CL = `${LanguageCode.Spanish}-${CountryCode.Chile}`,
	es_CO = `${LanguageCode.Spanish}-${CountryCode.Colombia}`,
	es_EC = `${LanguageCode.Spanish}-${CountryCode.Ecuador}`,
	es_PA = `${LanguageCode.Spanish}-${CountryCode.Panama}`,
	es_PE = `${LanguageCode.Spanish}-${CountryCode.Peru}`
}

export default LocaleCode
